export default __webpack_public_path__ + "static/media/Update3.8260dbdf.png";